import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IRequisitionPartialFields {
		id?: any;
		status?: any;
		datestamp?: any;
		changedById?: any;
		identifier?: any;
		latestRequisitionPartialWorkflowId?: any;
		exportedToSispro?: any;
		sisproIdentifier?: any;
sisproIdentifierPrefix?:any;
}

export class RequisitionPartialFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public changedById: IEntityModelField = { name: "changedById", displayName: "Changed By Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public identifier: IEntityModelField = { name: "identifier", displayName: "Identifier", fieldType: FieldType.String, pattern: "NameGeneric" };
	public latestRequisitionPartialWorkflowId: IEntityModelField = { name: "latestRequisitionPartialWorkflowId", displayName: "Latest Requisition Partial Workflow Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public exportedToSispro: IEntityModelField = { name: "exportedToSispro", displayName: "Exported To Sispro", fieldType: FieldType.Byte, pattern: "NameGeneric" };
  public sisproIdentifier: IEntityModelField = { name: "sisproIdentifier", displayName: "Sispro Identifier", fieldType: FieldType.Int, pattern: "NameGeneric" };
  public emailSent: IEntityModelField = { name: "emailSent", displayName: "Email sent", fieldType: FieldType.Byte, pattern: "NameGeneric" };
  public sisproIdentifierPrefix: IEntityModelField = { name: "sisproIdentifierPrefix", displayName: "Sispro Identifier", fieldType: FieldType.Int, pattern: "NameGeneric" };


	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.identifier);
		this.push(this.latestRequisitionPartialWorkflowId);
		this.push(this.exportedToSispro);
      this.push(this.sisproIdentifier);
      this.push(this.emailSent);
this.push(this.sisproIdentifierPrefix);
	}
}

export class RequisitionPartialDTO implements IEntityModel {
	protected requisitionPartialName: string = "RequisitionPartialModel";
	protected requisitionPartialKeyField: string = "id";
	protected requisitionPartialDisplayName: string = "Requisition Partial|Requisition Partials";
	protected requisitionPartialFields = new RequisitionPartialFields();
	public get name(): string { return this.requisitionPartialName };
	public get keyField(): string { return this.requisitionPartialKeyField };
	public get displayName(): string { return this.requisitionPartialDisplayName };
	public get fields(): RequisitionPartialFields { return this.requisitionPartialFields };

	constructor() {};
}
